/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { DataActionConditionType, DATA_ACTION_CONDITION_TYPE_LABEL } from 'cio/utils/campaigns/data-action';

interface DataActionTypeValueEditorTypeArgs {
  type: DataActionConditionType;
  onChange: (type: DataActionConditionType) => unknown;
  lowercase?: boolean;
  supportedConditionTypes: DataActionConditionType[];
  hasReadOnlyPermission: boolean;
}

export default class DataActionTypeValueEditorType extends Component<DataActionTypeValueEditorTypeArgs> {
  DataActionConditionType = DataActionConditionType;

  get typeSelectOptions() {
    let options = this.args.supportedConditionTypes.map((type) => ({
      label: DATA_ACTION_CONDITION_TYPE_LABEL[type],
      value: type,
    }));

    if (this.args.lowercase) {
      options = options.map((option) => ({
        ...option,
        label: option.value === DataActionConditionType.JavaScript ? option.label : option.label.toLowerCase(),
      }));
    }

    return options;
  }
}
